var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11560_30902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4C0 5.55167 5.55167 0 12.4 0C19.2483 0 24.8 5.55167 24.8 12.4C24.8 19.2483 19.2483 24.8 12.4 24.8C5.55167 24.8 0 19.2483 0 12.4Z",
    fill: "#D6F4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4004 0.200195C19.1381 0.200407 24.5996 5.66265 24.5996 12.4004C24.5994 19.138 19.138 24.5994 12.4004 24.5996C5.66265 24.5996 0.200407 19.1381 0.200195 12.4004C0.200195 5.66252 5.66252 0.200195 12.4004 0.200195Z",
    stroke: "#C2EECD",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11560_30902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 10.4004V15.9004C8.40039 16.1656 8.50575 16.42 8.69328 16.6075C8.88082 16.795 9.13517 16.9004 9.40039 16.9004H10.4004M16.4004 10.4004V15.9004C16.4004 16.1656 16.295 16.42 16.1075 16.6075C15.92 16.795 15.6656 16.9004 15.4004 16.9004H14.4004M10.9004 13.9004L12.4004 12.4004M12.4004 12.4004L13.9004 13.9004M12.4004 12.4004V16.9004M7.90039 7.90039H16.9004C17.1765 7.90039 17.4004 8.12425 17.4004 8.40039V9.90039C17.4004 10.1765 17.1765 10.4004 16.9004 10.4004H7.90039C7.62425 10.4004 7.40039 10.1765 7.40039 9.90039V8.40039C7.40039 8.12425 7.62425 7.90039 7.90039 7.90039Z",
    stroke: "#155024",
    strokeWidth: 0.933333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11560_30902",
    x: 0,
    y: 0,
    width: 24.8008,
    height: 24.8008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.487765 0 0 0 0 0.870746 0 0 0 0 0.581284 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11560_30902"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11560_30902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.40039 6.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestored);
export default __webpack_public_path__ + "static/media/restored.6aae25484c66e51b17fb47e8c8590ab7.svg";
export { ForwardRef as ReactComponent };